export default "__VITE_ASSET__CsyOAO_X__"